import { createContext } from 'react';

export const BrandContext = createContext();
